import { onlyNumbers } from './onlyNumbers';
const cnpj = function(value) {
  var data = onlyNumbers(value);
  if (!data) return '';
  var result = data.substr(0, 2) + '.' + data.substr(2, 3) + '.' + data.substr(5, 3) + '/' + data.substr(8, 4) + '-' + data.substr(12, 2);
  return result;
};

export { cnpj };
